import React from "react";

import {
    UniformSlot,
    UniformSlotWrapperComponentProps
} from "@uniformdev/canvas-react";

import {
    ColumnLayout,
    SubColumnLayout,
    type ColumnLayoutProps
} from "@/libraries/design/foundations";

const slotWrapper = ({ items }: UniformSlotWrapperComponentProps) => {
    return items.map((element, index) => {
        return <li key={index}>{element}</li>;
    });
};

// Compiled styling requires complex set of choices
export const UniformColumnLayout: React.FC<ColumnLayoutProps> = ({
    layout = "12",
    tabletLayout,
    mobileLayout,
    paddingTopv2,
    paddingBottomv2,
    verticalAlignment = "normal",
    renderAsList,
    mobileReverseOrder
}) => {
    return (
        <ColumnLayout
            layout={layout}
            tabletLayout={tabletLayout}
            mobileLayout={mobileLayout}
            paddingTopv2={paddingTopv2}
            paddingBottomv2={paddingBottomv2}
            verticalAlignment={verticalAlignment}
            renderAsList={renderAsList}
            mobileReverseOrder={mobileReverseOrder}
        >
            {
                <UniformSlot
                    name="content"
                    wrapperComponent={renderAsList ? slotWrapper : undefined}
                />
            }
        </ColumnLayout>
    );
};

// Compiled styling requires complex set of choices
export const UniformSubColumnLayout: React.FC<ColumnLayoutProps> = ({
    layout = "12",
    tabletLayout,
    mobileLayout,
    paddingTopv2,
    paddingBottomv2,
    verticalAlignment = "normal",
    renderAsList,
    mobileReverseOrder
}) => {
    return (
        <SubColumnLayout
            layout={layout}
            tabletLayout={tabletLayout}
            mobileLayout={mobileLayout}
            paddingTopv2={paddingTopv2}
            paddingBottomv2={paddingBottomv2}
            verticalAlignment={verticalAlignment}
            renderAsList={renderAsList}
            mobileReverseOrder={mobileReverseOrder}
        >
            {
                <UniformSlot
                    name="content"
                    wrapperComponent={renderAsList ? slotWrapper : undefined}
                />
            }
        </SubColumnLayout>
    );
};

// Both components are exported as named exports above
